<div class="container">

    <table id="reporteGeneral" class="table table-striped">
        <thead>
            <tr>
                 <th scope="col">Ticket</th>
                <th scope="col">Identidad</th>
                <th scope="col">Nombre</th>
                <th scope="col">Colegiación</th>
                <th scope="col">Departamento</th>
                <th scope="col">Municipio</th>
                <th scope="col">Estado</th>
                <th scope="col">Fecha/Hora</th>
                
                <th scope="col">Representado por</th>
                 <th scope="col">Atendido por</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of data">
                <td>{{p['ticket']}}</td>
                <td>{{p['identidad']}}</td>
                <td>{{p['nombreCompleto']}}</td>
                <td>{{p['numeroColegiacion']}}</td>
                <td>{{p['departamento']}}</td>
                <td>{{p['municipio']}}</td>
                <td>{{p['status']}}</td>
                <td>{{p['fechaVotacion'] | date: "dd/MM/yyyy"}} {{p['hora']}}</td>
               
                <td>{{p['representadoPor']}}</td>
                 <td>{{p['usuario']}}</td>
            </tr>
        </tbody>
    </table>
</div>